interface CodeBlockProps {
  content: string;
}

export const CodeBlock = ({ content }: CodeBlockProps) => {
  return (
    <div className="bitte-w-full">
      <pre className="bitte-disable-scrollbars bitte-w-full bitte-overflow-x-auto bitte-rounded-lg bitte-bg-secondary bitte-p-4 bitte-text-secondary-foreground">
        <code
          className="bitte-block bitte-w-[400px] bitte-bg-blue-950/80 bitte-font-mono bitte-text-sm"
          aria-label="Code example"
          style={{
            background: 'rgb(30 41 59 / 0.8) !important',
            backgroundColor: 'rgb(30 41 59 / 0.8) !important',
            whiteSpace: 'pre',
            display: 'block',
            border: 'none !important',
            borderRadius: '0 !important',
            padding: '0 !important',
          }}
        >
          {content}
        </code>
      </pre>
    </div>
  );
};
